import { Box, Field, Flex } from '@chakra-ui/react';

import { HelpPopover } from '../../HelpPopover';
import { ErrorMessage } from '../ErrorMessage';

type BaseInputProps = {
  children: React.ReactNode;
  error?: React.ReactNode;
  label?: string;
  helperText?: string;
  isRequired?: boolean;
  name?: string;
  optionalText?: string;
  ref?: React.RefObject<HTMLDivElement>;
};

export function BaseInput({
  children,
  error = '',
  label = '',
  helperText,
  isRequired = false,
  optionalText,
  ref,
}: BaseInputProps) {
  const withHelperText = Boolean(helperText);
  const hasLabel = Boolean(label);
  const hasError = Boolean(error);

  return (
    <Field.Root invalid={hasError} required={isRequired} ref={ref}>
      {hasLabel && (
        /*
          `htmlFor` здесь не указываем намеренно. Раньше стояло `htmlFor={name}`, но `id` полю
          выдаёт сам Chakra (`«r0»` и подобные), и подпись указывала на элемент, которого нет:
          клик по подписи не ставил курсор в поле, а скринридер читал поле безымянным. Без
          `htmlFor` `Field.Root` связывает подпись с полем своими id, и оба случая чинятся.
        */
        <Flex align="flex-end" gap={1} minW={0}>
          <Field.Label textStyle="title" color="fg.emphasized" minW={0}>
            <Box as="span" minW={0}>
              {label} <Field.RequiredIndicator fallback={optionalText} />
            </Box>
          </Field.Label>
          {/* Подсказка живёт в поповере у подписи, а не текстом под полем. Текстом её уже
              переносили: подсказки игровых настроек приходят из каталога на пять-шесть строк,
              и под полем они растягивали форму так, что следующее поле уезжало с экрана.
              Плюс вопросик остался у `OptionsGroup` («Цель игры», «Стиль игры»), и на одном
              шаге формы получалось два разных способа объяснить одно и то же. */}
          {withHelperText ? (
            <HelpPopover accessibleLabel={label} renderAsHtml compact>
              {helperText}
            </HelpPopover>
          ) : null}
        </Flex>
      )}
      {children}
      {hasError ? <ErrorMessage error={error} /> : null}
    </Field.Root>
  );
}
